import { useContext } from 'react'
import { TranslationContext } from './context'

export const useTranslation = () => {
  return useContext(TranslationContext);
}